// Product Compare Button (for product card)
class ProductCompare extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.info = JSON.parse(this.querySelector(".product-info-json")?.innerHTML);
  }

  connectedCallback() {
    this.button.addEventListener("click", () => {
      const event = new CustomEvent("product-compare-toggle", {
        bubbles: true,
        detail: {
          product: this.info,
        },
      });
      this.dispatchEvent(event);
    });
  }

  setSelected(selected) {
    this.button.classList.toggle("selected", selected);
  }
}

class ProductComparison extends HTMLElement {
  constructor() {
    super();
    this.selectedProducts = [];
    this.bar = null;
    this.overlay = null;
    this.compareButton = null;
    this.closeButton = null;
    this.clearButtons = [];
  }

  connectedCallback() {
    this.bar = this.querySelector("#product-compare-bar");
    this.overlay = this.querySelector(".compare-overlay");
    this.compareButton = this.bar.querySelector(".ProductCompareBar__Compare");
    this.closeButton = this.overlay.querySelector(".compare-modal__close");
    this.clearButtons = [
      this.bar.querySelector(".ProductCompareBar__Clear"),
      this.overlay.querySelector(".compare-modal__clear"),
    ];

    window.addEventListener("product-compare-toggle", (e) => {
      const product = e.detail.product;
      const index = this.selectedProducts.findIndex((p) => p.id === product.id);
      if (index === -1) {
        if (this.selectedProducts.length < 3) {
          this.selectedProducts.push(product);
        } else {
          return;
        }
      } else {
        this.selectedProducts.splice(index, 1);
      }
      this.render();
      this.updateCompareButtons();
    });

    this.compareButton?.addEventListener("click", () => {
      this.overlay.classList.add("is-active");
      document.body.classList.add("no-scroll");
      window?.yotpoWidgetsContainer?.initWidgets();
    });

    this.closeButton?.addEventListener("click", () => {
      this.overlay.classList.remove("is-active");
      document.body.classList.remove("no-scroll");
    });

    this.clearButtons.forEach((button) => {
      button?.addEventListener("click", () => {
        this.selectedProducts = [];
        this.render();
        this.updateCompareButtons();
        setTimeout(() => {
          this.overlay.classList.remove("is-active");
          document.body.classList.remove("no-scroll");
        }, 0);
      });
    });

    this.render();
    this.updateCompareButtons();
  }

  render() {
    // Render bar
    const items = this.bar.querySelectorAll(".ProductCompareBar__Item");
    items.forEach((item, i) => {
      const product = this.selectedProducts[i];
      if (product) {
        item.setAttribute("data-product-id", product.id);
        item.classList.remove("ProductCompareBar__Item--empty");
        item.innerHTML = `
          ${product.image}
          <button class="ProductCompareBar__Remove" data-product-id="${product.id}">
            <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1L1 8L8 1ZM8 8L1 1L8 8Z" fill="white"/>
              <path d="M8 1L1 8M8 8L1 1" stroke="#1C1B1B" stroke-width="0.875"/>
            </svg>
          </button>
        `;
        const removeButton = item.querySelector(".ProductCompareBar__Remove");
        removeButton.addEventListener("click", () => {
          this.selectedProducts = this.selectedProducts.filter((p) => p.id !== product.id);
          this.render();
          this.updateCompareButtons();
        });
      } else {
        item.classList.add("ProductCompareBar__Item--empty");
        item.innerHTML = "<div></div>";
        item.removeAttribute("data-product-id");
      }
    });

  const cardsContainer = this.overlay.querySelector(".compare-modal__cards");
  cardsContainer.innerHTML = "";
    this.selectedProducts.forEach((product) => {
      console.log(product);
      
    const card = document.createElement("div");
    card.setAttribute("data-item-id", product.id);
    card.classList.add("compare-modal__card");
    
    card.innerHTML = `
      <div class="compare-modal__card-media-wrapper">
        ${product.image}
        <button class="compare-modal__card-remove" data-product-id="${product.id}">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9 1L1 9L9 1ZM9 9L1 1L9 9Z" fill="currentColor"/>
            <path d="M9 1L1 9M9 9L1 1" stroke="#1C1B1B" stroke-width="0.875"/>
          </svg>
        </button>
        ${product.gender != '' ? `<div class="ProductItem_BDG_Badge">
          <div class="ProductItem__Label Heading Text--subdued">
            <span>${product.gender}</span>
          </div>
        </div>` : null}
      </div>
      <div class="ProductItem__Info ProductItem__Info--left">
        <div>
          <div class="ProductItem__Header">
            <h2 class="ProductItem__Title Heading">
              <a href="${product.url}">${product.title}</a>
            </h2>
            <div class="ProductItem__PriceList Heading"><span class="ProductItem__Price Price Price--noDiscount Text--subdued">${product.price}</span></div>
          </div>
        </div>
        <div class="ProductItem__PriceList Heading show-mobile"><span class="ProductItem__Price Price Price--noDiscount Text--subdued">${product.price}</span></div>
        <div>${product.short_description}</div>
      </div>
      <a href="${product.url}" class="compare-modal__card-link">${window.languages.comparison.view_product}</a>
    `;
    const removeButton = card.querySelector(".compare-modal__card-remove");
    removeButton.addEventListener("click", () => {
      this.selectedProducts = this.selectedProducts.filter((p) => p.id !== product.id);
      this.render();
      this.updateCompareButtons();
      if (this.selectedProducts.length === 0) {
        this.overlay.classList.remove("is-active");
        document.body.classList.remove("no-scroll");
      }
    });
    cardsContainer.appendChild(card);
  });

    // Render overlay cards
    const stickyCardsContainer = this.overlay.querySelector(".compare-modal__cards-sticky");
    stickyCardsContainer.innerHTML = "";
    this.selectedProducts.forEach((product) => {
      const card = document.createElement("div");
      card.setAttribute("data-item-id", product.id);
      card.classList.add("compare-modal__card");
      card.innerHTML = `
        <div class="compare-modal__card-img-wrapper">
          ${product.image}
          <button class="compare-modal__card-remove" data-product-id="${product.id}">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9 1L1 9L9 1ZM9 9L1 1L9 9Z" fill="currentColor"/>
              <path d="M9 1L1 9M9 9L1 1" stroke="#1C1B1B" stroke-width="0.875"/>
            </svg>
          </button>
        </div>
        <div class="ProductItem__Info ProductItem__Info--left">
          <div class="ProductItem__Header">
            <h2 class="ProductItem__Title Heading">
              <a href="${product.url}">${product.title}</a>
            </h2>
            <div class="ProductItem__PriceList  Heading"><span class="ProductItem__Price Price Price--noDiscount Text--subdued">${product.price}</span></div>
          </div>
          <a href="${product.url}" class="compare-modal__card-link">${window.languages.comparison.view_product}</a>
        </div>
      `;
      const removeButton = card.querySelector(".compare-modal__card-remove");
      removeButton.addEventListener("click", () => {
        this.selectedProducts = this.selectedProducts.filter((p) => p.id !== product.id);
        this.render();
        this.updateCompareButtons();
        if (this.selectedProducts.length === 0) {
          this.overlay.classList.remove("is-active");
          document.body.classList.remove("no-scroll");
        }
      });
      stickyCardsContainer.appendChild(card);
      const addedImage = stickyCardsContainer.querySelector("img");
      addedImage.classList.add("productcomparebar__image");
    });

    // Render overlay rows
    const rows = this.overlay.querySelectorAll("[data-row]");
    rows.forEach((row) => {
      const key = row.getAttribute("data-row");
      const content = row.querySelector(".compare-modal__row-content");
      content.innerHTML = "";
      this.selectedProducts.forEach((product) => {
        const div = document.createElement("div");
        div.setAttribute("data-item-id", product.id);
        switch (key) {
          case "available_sizes":
            if (Array.isArray(product[key])) {
              div.innerHTML = product[key]
                .map((size) => `<span class="SizeSwatch">${size === "ONE SIZE" ? "OS" : size}</span>`)
                .join("");
            } else {
              div.innerHTML = "-";
            }
            break;
          default:
            if (product[key]) {
              div.innerHTML = product[key];
            } else {
              div.innerHTML = "-";
            }
        }
        content.appendChild(div);
      });
    });

    // Update compare button state
    this.compareButton.disabled = this.selectedProducts.length === 0;
    this.compareButton.textContent = this.selectedProducts.length > 0 
      ? `${window.languages.comparison.compare} (${this.selectedProducts.length})` 
      : window.languages.comparison.compare;
  }

  updateCompareButtons() {
    // Update all product-compare buttons
    const compareButtons = document.querySelectorAll("product-compare");
    compareButtons.forEach((btn) => {
      const info = btn.info;
      btn.setSelected(this.selectedProducts.some((p) => p.id === info.id));
    });
  }
}

class ProductComparisonToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("button");
    this.active = false;
    this.button.onclick = () => {
      this.active = !this.active;
      this.button.classList.toggle("active", this.active);
      document.body.classList.toggle("compare-mode", this.active);
    };
  }
}

customElements.define("product-compare", ProductCompare);
customElements.define("product-comparison", ProductComparison);
customElements.define("product-comparison-toggle", ProductComparisonToggle);
